export { default } from './WindowDefault'
